import React from "react";
import PrimaryButton from "../buttons/PrimaryButton";
import SecondaryButton from "../buttons/SecondaryButton";

interface PopUpProps {
  message: string;
  onClose: () => void;
  onConfirm: () => void;
}

const PopUp: React.FC<PopUpProps> = ({ message, onClose, onConfirm }) => {
  return (
    <div className="fixed inset-0 flex justify-center items-center z-50 bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg overflow-hidden w-[90%] sm:w-[400px] p-4">
        <div className="px-4 py-2">
          <h3 className="text-lg font-semibold text-gray-800 mb-2">
            Confirmation
          </h3>
          <p className="text-gray-600">{message}</p>
        </div>
        <div className="flex justify-end space-x-4 mt-4 px-4 py-2 ">
          <SecondaryButton type="button" onClick={onClose}>
            Cancel
          </SecondaryButton>
          <PrimaryButton type="button" onClick={onConfirm}>
            Confirm
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
};

export default PopUp;
